import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Container = ({
  children,
  className,
  style,
  paddingHorizontal,
  paddingVertical,
  heightFull,
  id
}) => (
  <div
    id={id}
    className={classnames(
      'flex flex-col rounded-sm common-container',
      { 'h-full': heightFull },
      className,
    )}
    style={{
      paddingLeft: paddingHorizontal,
      paddingRight: paddingHorizontal,
      paddingTop: paddingVertical,
      paddingBottom: paddingVertical,
      ...style,
    }}
  >
    {children}
  </div>
);

Container.defaultProps = {
  style: {},
  className: '',
  paddingHorizontal: null,
  paddingVertical: null,
  heightFull: true,
  id: null,
};

Container.propTypes = {
  // children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  paddingHorizontal: PropTypes.number,
  paddingVertical: PropTypes.number,
  heightFull: PropTypes.bool,
  id: PropTypes.string
};

export default Container;
